import { escape as encode } from 'he';

export function escape(str: string | undefined | null): string {
  return str ? encode(str) : '';
}
